import { getAttributes } from '@lumapps/data-attributes';

(function IIFE() {
    'use strict';

    /////////////////////////////

    function AdminItemActionsController() {
        'ngInject';

        var vm = this;

        /**
         * Services and utilities.
         */
        vm.dataScope = 'picker';

        /**
         * 
         * @param {Object} options 
         * @param {string} options.element 
         * @param {string} options.action 
         * @returns 
         */
        function getDataId(scope, options) {
            return getAttributes(scope)(options)['data-id'];
        }

        function isActionsEmpty(actions) {
            return !actions?.children?.some((action) => action?.visibility(vm.item));
        }

        vm.getDataId = getDataId;
        vm.isActionsEmpty = isActionsEmpty;
    }
    /////////////////////////////

    /**
     * Admin item actions directive.
     * Display given actions for an admin item in the data table or in the admin header.
     *
     * @param {Object} actions The admin item actions separated in primary and secondary sections.
     */

    function AdminItemActionsDirective() {
        return {
            bindToController: true,
            controller: AdminItemActionsController,
            controllerAs: 'vm',
            replace: true,
            restrict: 'E',
            scope: {
                actions: '=',
                item: '=',
                viewMode: '@',
            },
            templateUrl: '/client/common/modules/layout/modules/admin/views/admin-item-actions.html',
        };
    }

    /////////////////////////////

    angular.module('Directives').directive('adminItemActions', AdminItemActionsDirective);
})();